import(/* webpackMode: "eager" */ "/home/runner/_work/nvs-code/nvs-code/common/temp/node_modules/.pnpm/next@14.2.35_fjr73kb34ne2xuj5u2spjjhswa/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BaseLayout"] */ "/home/runner/_work/nvs-code/nvs-code/web/app/components/BaseLayout.tsx");
